// select box tooltips when always shown
const hideTips = elements => {
  Array.prototype.forEach.call(elements, el => {
    tdp_removeClass(el, "show");
  });

};

function selectTooltipChangeHandler(e) {
  const tips = Array.from(e.target.parentNode.querySelectorAll(".input-tooltip"));
  hideTips(tips);
  tdp_addClass(e.target.parentNode.querySelector(`.input-tooltip[data-id=${e.target.value}]`), "show");
  //updateRegion();
}

function selectTooltipParentChangeHandler(e) {
  const selectChildren = document.querySelectorAll(`.${e.target.getAttribute("data-tooltip-child")}`);
  Array.prototype.forEach.call(selectChildren, childSelect => {
    const tips = Array.from(childSelect.parentNode.querySelectorAll(".input-tooltip"));   
	hideTips(tips);
  });
}

/*function updateRegion() {
		var roleSelect = document.querySelectorAll(".js-role-list")[0];
		var regionSelect = document.querySelectorAll(".js-region-list")[0];
		var val = roleSelect.value;
		if (val == 'TFSLevel2' || val == 'TMCALevel2') 
		{
			if (regionSelect.length != 7) {
				var option = document.createElement('option');
				option.text = "National";
				option.value = "ALL";
				regionSelect.add(option, 1);
			}

		} 
		else 
		{
			for (var i = 0; i < regionSelect.length; i++) {
				if (regionSelect.options[i].value == 'ALL') {
					regionSelect.remove(i);

				}
			}
		}
	}*/


const selectTooltipChangeEvent = new CustomEvent("change");

const buildDealerList = () => {
  axios
    .get("/api/Dealer/GetDealersForMe")
    .then(response => {
      const sites = response.data;
      const dealerList = document.getElementById("js-nav-deal-list");
      dealerList.innerHTML = "";
      for (let i = 0; i < sites.length; i += 1) {
        const liTag = document.createElement("li");
        const aTag = document.createElement("a");
        aTag.setAttribute("href", `/Account/DealerSwitch?dealerId=${sites[i].value}`);
        aTag.innerHTML = sites[i].text;
        liTag.appendChild(aTag);
        dealerList.appendChild(liTag);
      }
      toggleVisibility("js-deal-load", false);
      toggleVisibility("js-dealer-drop-list", true);
    })
    .catch(error => {
      console.log(error); // eslint-disable-line
    });
};

const loadList = () => { // eslint-disable-line
  const ele = document.getElementById("js-nav-deal-tog");
  if (!ele.parentNode.classList.contains("dealers--open")) {
    toggleVisibility("js-deal-load", true);
    toggleVisibility("js-dealer-drop-list", false);
    buildDealerList();
  }
};

// READY
tdp_ready(() => {
  const dealerNavRoot = document.querySelector(".user-nav-dealer-select");
  const dealerNavList = document.querySelector(".user-nav-dealer-list");
  const dealerNavToggle = document.querySelector(".user-nav-dealer-toggle");
  const menuEl = document.getElementById("ml-menu");

  // dealer nav switch
  const openDealerList = () => {
    $.Velocity.animate(dealerNavList, "slideDown");
    tdp_addClass(dealerNavRoot, "dealers--open");
  };

  const closeDealerList = () => {
    $.Velocity.animate(dealerNavList, "slideUp");
    tdp_removeClass(dealerNavRoot, "dealers--open");
    if (dealerNavToggle) {
      dealerNavToggle.blur();
    }
  };

  if (dealerNavToggle && dealerNavList) {
    dealerNavToggle.addEventListener("click", () => {
      if (!tdp_hasClass(dealerNavRoot, "dealers--open")) {
        openDealerList();
      } else {
        closeDealerList();
      }
      if (tdp_hasClass(document.body, "body--menu--open")) {
        closeMenu();
      }
    });
  }

  // side navigation
  if (menuEl) {
    const openMenuCtrl = document.querySelector(".action--open");
    const closeMenuCtrl = document.querySelector(".action--close");

    const openMenu = () => {
      console.log('open')
      classie.add(document.body, "body--menu--open");
      classie.add(menuEl, "menu--open");
      if (tdp_hasClass(dealerNavRoot, "dealers--open")) {
        closeDealerList();
      }
      closeMenuCtrl.focus();
    };

    const closeMenu = () => {
      classie.remove(document.body, "body--menu--open");
      classie.remove(menuEl, "menu--open");
      openMenuCtrl.focus();
    };

    openMenuCtrl.addEventListener("click", openMenu);
    closeMenuCtrl.addEventListener("click", closeMenu);

    $('.expand-menu button').on('click', function(e){
      e.preventDefault();
      var $me = $(this);
      var id = $me.attr('aria-controls');
      var pressed = $me.attr('aria-pressed').toLowerCase() == "true";
      var $menu = $("#" + id);
      $me.attr('aria-pressed', (!pressed).toString().toLowerCase());
      $menu.attr('aria-expanded', (!pressed).toString().toLowerCase());
    });
    $('.expand-menu a[href="#"]').on('click', function(e){
      e.preventDefault();
      var $me = $(this);
      var $btn = $me.next('button');
      $btn.length && $btn.trigger('click');
    });

    location.pathname && location.pathname != '/' && $('.expand-menu a[href^="' + location.pathname + '"]').addClass('active');

    setTimeout(function(){
      $('.expand-menu').removeClass('uninit');
    },1)

    

    // const mlmenu = new MLMenu(menuEl, { // eslint-disable-line
    //   breadcrumbsCtrl: true,
    //   initialBreadcrumb: "",
    //   backCtrl: true,
    //   itemsDelayInterval: 25,
    //   onItemClick: closeMenu
    // });

    // simulate click if starting on an inner page
    // const pageParent = document.querySelector('[data-context="1"] a');
    // if (pageParent) {
    //   simulateClick(pageParent);
    // }
    // // add transitions after simulated click
    // setTimeout(() => {
    //   classie.add(menuEl, "menu-transitions");
    // }, 1000);
  }

  // table sorting
  document.getElementsByTagName("body")[0].addEventListener("click", e => {
    if (e.target.classList.contains("js-order")) {
      e.preventDefault();
      const orderId = e.target.getAttribute("data-order-id");
      if (typeof orderId !== "undefined") {
        document.getElementById("OrderById").value = orderId;
        e.target.closest("form").submit();
      }
    }
  });

  // select box tooltips when always shown
  const selectsWithTooltip = document.querySelectorAll("select.has-tooltip");
  Array.prototype.forEach.call(selectsWithTooltip, el => {
    tdp_addClass(el.parentNode.querySelector(`.input-tooltip[data-id=${el.value}]`), "show");
    el.addEventListener("change", selectTooltipChangeHandler);
  });

  const selectWithTooltipParentSelects = document.querySelectorAll("select[data-tooltip-child]");
  Array.prototype.forEach.call(selectWithTooltipParentSelects, el => {
    el.addEventListener("change", selectTooltipParentChangeHandler);
  });
});
